import React, {useState} from "react";
import {stringUtil} from "../../../res/dataServices/string";
import TextInput from "../../../components/general/input/Input";
import {Button} from "../../../components/general/input/Button";
import ComponentRenderer from "../../core/context/componentRegistry/ComponentRenderer";

const QuantityInput = ({ qtyEntered, updateQuantity, disabled, updating }) => {

    const [ passedQtyEntered, setPassedQtyEntered ] = useState(qtyEntered);
    const [ inputQuantity, setInputQuantity ] = useState(
        qtyEntered && qtyEntered > 0 ? qtyEntered : -1
    );

    if(passedQtyEntered !== qtyEntered) {
        setPassedQtyEntered(qtyEntered);
        setInputQuantity(qtyEntered);
    }

    const onQtyChanged = (e) => {
        const inputValue = e.target.value;
        const onlyNumbers = stringUtil.removeNonNumbers(inputValue);
        if(!onlyNumbers) {
            setInputQuantity(0);
        }

        const asNumber = Number(onlyNumbers);
        if(asNumber > 999) {
            setInputQuantity(999)
        } else if(asNumber < 1) {
            setInputQuantity(0);
        } else {
            setInputQuantity(asNumber);
        }
    }

    const onUpdateQuantity = (input) => {
        if(disabled) return;
        const qtyEntered = input > -1 ? input : inputQuantity;
        if(qtyEntered < 0) {
            updateQuantity(1);
        } else {
            updateQuantity(qtyEntered);
        }
    }

    const buttonText = qtyEntered > 0 ? "Update" : "Add";

    const buttonClass = updating ? "loading" : disabled ? "inactive" : "";

    return (
        <div className='prod-input-quantity-container'>
            <TextInput
                disabled={disabled}
                onChange={onQtyChanged}
                value={inputQuantity > -1 ? inputQuantity : ""}
            />
            <Button
                className={buttonClass}
                onClick={onUpdateQuantity}
            >{buttonText}</Button>
        </div>
    )
}

const ProductQuantityInput = ({ qtyEntered, updateQuantity, disabled, updating }) => {
    return <ComponentRenderer
        componentName="productQuantityInput"
        defaultComponent={QuantityInput}
        props={{ qtyEntered, updateQuantity, disabled, updating }}
    />
}

export default ProductQuantityInput;
